import { IconName } from "shared/ui/icon/__generated__/IconName"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface SelectOption<T, DataType = any> {
  key?: string
  value: T
  label: string
  disabled?: boolean
  creatable?: boolean
  icon?: IconName
  image?: React.ReactNode
  data?: DataType
  "data-testid"?: string
}

export function isSelectOption<T>(
  option?: T | SelectOption<T>
): option is SelectOption<T> {
  return (
    !!option && typeof option === "object" && Object.hasOwn(option, "label")
  )
}

export type OnFocusedOptionChange<T> = (args: {
  index: number
  total: number
  option: SelectOption<T>
  isSelected: boolean | undefined
  selectedOptionTotal?: number
}) => void
